'use strict';

define('forum/home', ['topicList', 'sideSf', 'bannerCarousel'], function (topicList, sideSf, bannerCarousel) {

    var Home = {};

    Home.init = function () {
            sideSf.init();

            const carouselParentEl = $('.banner-carousel-header')
            carouselParentEl.removeClass('hide');
            bannerCarousel.init();
            topicList.init('recent');

            $(window).on("action:ajaxify.start", (ev, data) => {

                carouselParentEl.addClass('hide');
            });
    };
    return Home;
});
